import React, {FC} from "react"
import { ButtonGroup, Dropdown, DropdownButton } from "react-bootstrap"
import IntlProps from "../../state/helpers/IntlProps"
import { injectIntl } from "react-intl"
import { colorListMessages } from "../messages/messages"

const colors = ["primary", "secondary", "success", "danger", "warning", "info", "custom-secondary"]

interface Props {
    onChange: (value: string) => void
    value?: string
    className?: string
}

const ColorDropdownButton: FC<Props & IntlProps> = ({ onChange, value="primary", intl , className= ""}) => {
    
    const onSelect = (eventKey: string | null) => {
        if(eventKey == null) return
        onChange(eventKey)
    }

    return (
        <DropdownButton
            as={ButtonGroup}
            variant={value}
            onSelect={onSelect}
            title={intl.formatMessage(colorListMessages[value])}
            className={className}
        >
            {
                colors.map((color) =>
                    <Dropdown.Item key={color} eventKey={color}  className={`text-${color}`}>
                        {intl.formatMessage(colorListMessages[color])}
                    </Dropdown.Item>
                )
            }
        </DropdownButton>
    )
}

export default injectIntl(ColorDropdownButton)


// WEBPACK FOOTER //
// ./src/shortcuts/components/ColorDropdownButton.tsx